import AjaxLoad from '../../lib/ajax-load';

class ContactForm {
    constructor ($contact, options) {
        this.$contact = $contact;
        this.$contactForm = $contact.querySelector('form');

        const settings = {
            onSubmitted: null
        };

        this.settings = Object.assign({}, settings, options);
    }

    init () {
        if (this.$contactForm) {
            this.setEvents();
        }
    }

    sendTrackingData () {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({ // eslint-disable-line no-undef
            event: 'Kontakt',
            request: 'Contact request was sent.'
        });
    }

    setEvents () {
        this.$contactForm.addEventListener('submit', (e) => {
            e.preventDefault();
            this.sendForm(this.$contactForm.getAttribute('action'));
        });
    }

    sendForm (url) {
        this.$contact.classList.add('is--loading');

        const ajaxLoad = new AjaxLoad(url, {
            requestMethod: 'POST',
            requestData: new FormData(this.$contactForm),
            onSuccess: (result) => {
                this.setForm(result, () => {
                    if (typeof this.settings.onSubmitted === 'function') {
                        this.settings.onSubmitted(this.$contact);
                    }
                });
            }
        });

        ajaxLoad.initialize();
    }

    setForm (result, callback) {
        const results = JSON.parse(result.toString());

        if (results.submitSuccess) {
            this.sendTrackingData();
        }

        const template = document.createElement('div');

        if (results.html !== '') {
            template.innerHTML = results.html;
        }

        this.$contact.innerHTML = template.innerHTML;

        setTimeout(() => {
            this.$contact.classList.remove('is--loading');

            if (typeof callback === 'function') {
                callback();
            }
        }, 200);
    }
}

export { ContactForm };
